import { render, staticRenderFns } from "./returnVisit.vue?vue&type=template&id=4335807a&"
import script from "./returnVisit.vue?vue&type=script&lang=js&"
export * from "./returnVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4335807a')) {
      api.createRecord('4335807a', component.options)
    } else {
      api.reload('4335807a', component.options)
    }
    module.hot.accept("./returnVisit.vue?vue&type=template&id=4335807a&", function () {
      api.rerender('4335807a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/complaintManage/suggestQuery/returnVisit.vue"
export default component.exports